import React, { useState } from "react";
import PointListingTableComponent from "./pointListingTable.component";
import { useSelector } from "react-redux";
import { AddPointDialog } from "../../dialog";

export default function PointListingTableContainer({
  hasLoyaltyProgramAddAccessRight,
  hasLoyaltyProgramEditAccessRight,
  hasLoyaltyProgramActivateOrDeactivateAccessRight,
  data,
  isFetching,
  page,
  search,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  handleCreate,
  handleStatusChange,
  handleReload,
  paginationOptions,
}) {
  const isLoadingPointError = useSelector(
    (state) => state.loyaltyProgram.isLoadingPointError
  );
  const lang = useSelector((state) => state.constant.languages);
  const language = useSelector((state) => state.profile.language);

  const [selectedPointId, setSelectedPointId] = useState(null);

  const handleView = (record) => {
    setSelectedPointId(record.id);
  };

  const handleClose = () => {
    setSelectedPointId(null);
  };

  return (
    <>
      <PointListingTableComponent
        hasLoyaltyProgramAddAccessRight={hasLoyaltyProgramAddAccessRight}
        hasLoyaltyProgramEditAccessRight={hasLoyaltyProgramEditAccessRight}
        hasLoyaltyProgramActivateOrDeactivateAccessRight={
          hasLoyaltyProgramActivateOrDeactivateAccessRight
        }
        data={data}
        isFetching={isFetching}
        page={page}
        search={search}
        rowsPerPage={rowsPerPage}
        totalRecords={totalRecords}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        language={language}
        handleCreate={handleCreate}
        handleView={handleView}
        handleStatusChange={handleStatusChange}
        handleReload={handleReload}
        isLoadingPointError={isLoadingPointError}
        paginationOptions={paginationOptions}
        lang={lang}
      />
      <AddPointDialog
        isOpen={!!selectedPointId}
        handleClose={handleClose}
        id={selectedPointId}
        type="view"
        handleReload={handleReload}
      />
    </>
  );
}
